module.exports = __webpack_public_path__ + "static/media/hk_icon.b5140b27.png";